import axios from 'axios'

// Configuration de base pour l'API
const API_BASE_URL = '/api'

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})

// Service API pour Body Metrics
export const bodyMetricsAPI = {
  // Récupérer tous les utilisateurs
  async getUsers() {
    try {
      const response = await api.get('/users')
      return response.data
    } catch (error) {
      console.error('Erreur lors de la récupération des utilisateurs:', error)
      throw error
    }
  },

  // Récupérer un utilisateur spécifique
  async getUser(userId) {
    try {
      const response = await api.get(`/users/${userId}`)
      return response.data
    } catch (error) {
      console.error(`Erreur lors de la récupération de l'utilisateur ${userId}:`, error)
      throw error
    }
  },

  // Mettre à jour les données complètes d'un utilisateur
  async updateUser(userId, userData) {
    try {
      const response = await api.put(`/users/${userId}`, { data: userData })
      return response.data
    } catch (error) {
      console.error(`Erreur lors de la mise à jour de l'utilisateur ${userId}:`, error)
      throw error
    }
  },

  // Ajouter une nouvelle mesure
  async addMeasurement(userId, measurement) {
    try {
      const response = await api.post(`/users/${userId}/measurements`, { measurement })
      return response.data
    } catch (error) {
      console.error(`Erreur lors de l'ajout de la mesure pour ${userId}:`, error)
      throw error
    }
  },

  // Mettre à jour une mesure existante
  async updateMeasurement(userId, measurementId, measurement) {
    try {
      const response = await api.put(`/users/${userId}/measurements/${measurementId}`, { measurement })
      return response.data
    } catch (error) {
      console.error(`Erreur lors de la mise à jour de la mesure ${measurementId}:`, error)
      throw error
    }
  },

  // Supprimer une mesure
  async deleteMeasurement(userId, measurementId) {
    try {
      const response = await api.delete(`/users/${userId}/measurements/${measurementId}`)
      return response.data
    } catch (error) {
      console.error(`Erreur lors de la suppression de la mesure ${measurementId}:`, error)
      throw error
    }
  },

  // Vérifier l'état du serveur
  async checkHealth() {
    try {
      const response = await api.get('/health')
      return response.data
    } catch (error) {
      console.error('Erreur lors de la vérification de l\'état du serveur:', error)
      throw error
    }
  },

  // ========== MÉTHODES POUR LES OBJECTIFS ==========

  // Ajouter un nouvel objectif
  async addGoal(userId, goal) {
    try {
      const response = await api.post(`/users/${userId}/goals`, { goal })
      return response.data
    } catch (error) {
      console.error(`Erreur lors de l'ajout de l'objectif pour ${userId}:`, error)
      throw error
    }
  },

  // Modifier un objectif
  async updateGoal(userId, goalId, goal) {
    try {
      const response = await api.put(`/users/${userId}/goals/${goalId}`, { goal })
      return response.data
    } catch (error) {
      console.error(`Erreur lors de la modification de l'objectif ${goalId}:`, error)
      throw error
    }
  },

  // Archiver un objectif
  async archiveGoal(userId, goalId) {
    try {
      const response = await api.put(`/users/${userId}/goals/${goalId}/archive`)
      return response.data
    } catch (error) {
      console.error(`Erreur lors de l'archivage de l'objectif ${goalId}:`, error)
      throw error
    }
  },

  // Désarchiver un objectif
  async unarchiveGoal(userId, goalId) {
    try {
      const response = await api.put(`/users/${userId}/goals/${goalId}/unarchive`)
      return response.data
    } catch (error) {
      console.error(`Erreur lors du désarchivage de l'objectif ${goalId}:`, error)
      throw error
    }
  },

  // Supprimer un objectif
  async deleteGoal(userId, goalId) {
    try {
      const response = await api.delete(`/users/${userId}/goals/${goalId}`)
      return response.data
    } catch (error) {
      console.error(`Erreur lors de la suppression de l'objectif ${goalId}:`, error)
      throw error
    }
  }
}

export default bodyMetricsAPI
